export const EDIT_PROFILE_SUCCESS="profile/EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAILURE="profile/EDIT_PROFILE_FAILURE";
export const PROFILE_DETAILS_SUCCESS="profile/PROFILE_DETAILS_SUCCESS";
export const PROFILE_DETAILS_FAILURE="profile/PROFILE_DETAILS_FAILURE";
export const PROFILE_COMPLETION_SUCCESS="profile/PROFILE_COMPLETION_SUCCESS";
export const PROFILE_COMPLETION_FAILURE="profile/PROFILE_COMPLETION_FAILURE";
